import { useT } from '@transifex/react'
import { useSelector } from 'react-redux'
import { isReturn } from '../../../functions/sale'
import { useSaleManager, useVdCurrencyFilter } from '../../../ng-compat/hooks'
import { useAppSelector } from '../../../state/hooks'
import {
  selectCurrentSale,
  selectEcomCustomCharges,
} from '../../../state/slices/currentSale/currentSaleSlice'
import { CustomPopoverRowProp } from './SaleEcomCustomChargesPopover'

/**
 * Hook to get the Ecom custom charges in a sale.
 * This hook is used in the sale popover at sale footer
 */
export const useDisplayEcomCustomSurchargesRow = (): CustomPopoverRowProp[] => {
  const ecomCustomCharges = useAppSelector(selectEcomCustomCharges)
  const t = useT()

  const currentSale = useSelector(selectCurrentSale)
  const isReturnSale = isReturn(currentSale)
  const vdCurrencyFilter = useVdCurrencyFilter()
  const result: CustomPopoverRowProp[] = []
  const saleManager = useSaleManager()

  if (ecomCustomCharges?.totalIncl === 0) return []

  ecomCustomCharges?.charges.forEach((charge, index) => {
    result.push({
      id: charge.sourceId,
      name: charge.name,
      value: vdCurrencyFilter(charge.totalIncl),
      button: {
        isDisable: false,
        isVisible: isReturnSale,
        label: t('Delete ecom custom charge', { _context: 'Button label' }),
        onClick: isReturnSale
          ? saleManager.removeEcomCustomCharge
          : () => false,
      },
    })
  })

  return result
}
